import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import classNames from 'classnames';
import IconComponent from '../../iconComponent';
import SideBarContainer from './index';
import styles from './style.scss';

@inject('oidcStore', 'translationsStore') @observer
export default class SideBar extends Component {

    logout = (e) => {

        this.props.oidcStore.logout();
    }

    render() {

        let menu = null;
        
        if (this.props.oidcStore.currentUser === undefined) {

            return null;
        }

        const popoverClickRootClose = (
            <Popover id='popover-my-profile'
                className={classNames(styles.myProfileTooltipContainer)}
                positionLeft={16}
                positionTop={150}
                >
                <div className='left-container'>
                    <IconComponent iconClassName='user-large-icon' />
                </div>
                <div className={classNames(styles.rightContainer)}>
                    <div className={styles.userFullName}
                        title={this.props.oidcStore.currentUser.profile.name}>
                        {this.props.oidcStore.currentUser.profile.name}
                    </div>
                    <div className={classNames(styles.linksContainer)}>
                        <span
                            className={classNames(styles.portalBlankButton, styles.link)}
                            onClick={this.logout}
                            data-cy='logout-link'
                        >
                            {this.props.translationsStore.translate('LOGOUT')}
                        </span>
                    </div>
                </div>
            </Popover>
        );

        menu = <SideBarContainer>
                    <div
                        className={classNames(['my-account-icon-container'])}
                        data-tip data-for='my-profile-menu'
                    >
                            <OverlayTrigger
                                className={classNames(styles.myaccountIconContainerPopover)}
                                trigger='click'
                                rootClose
                                placement='top'
                                overlay={popoverClickRootClose}>
                                <button className={classNames(['my-account-icon'])}></button>
                            </OverlayTrigger>
                        </div>
                </SideBarContainer>;

        return (
            <div>
                {menu}
            </div>
        );
    }
}